<template>
  <div class="about">
    <b-container>
		<b-row>
             <b-col class="text-center">
            <router-link to="/">Home</router-link> |
            <router-link to="/viewUnresolvedJobs">View Jobs</router-link> |
            <router-link to="/viewResolvetickets">View Tickets</router-link> |
            <router-link to="/createTicket">Create Tickets</router-link> 
            <br>
            <br>
            </b-col>
        </b-row>
        <b-row>
         <b-col class="text-center">
            <img src="img/logo.png" class="center-block" alt="EnergyDrive">
            </b-col>
        </b-row><br>
		<b-row >
             <b-col class="text-left">
			<small>View Tickets</small><hr>
        </b-col>
		</b-row>
        <b-row>
            <b-col>
                <br>
            </b-col>
        </b-row>
		<b-row >
			<hr>		
            <b-col>
                <b>Ticket #</b>
             </b-col>
             <b-col>
                <input type="text" name="idTicket" id="idTicket" class="form-control" v-model="searchTicket">
            </b-col>
        
       
             <b-col>
                <!--<button type="submit" value="Search for a specific Ticket" class="btn btn-primary" id="search_idTicket" style="width:100%;" @click="clickButtonFindTicket"></button>-->
                <button class="btn btn-primary"  @click="clickButtonFindTicket">Search</button>
             </b-col>
            </b-row>
        <br>
         <b-row >
             <b-col>
                <!--<button type="submit" value="Search for a specific Ticket" class="btn btn-primary" id="search_idTicket" style="width:100%;" @click="clickButtonFindTicket"></button>-->
                <button class="btn btn-primary"  @click="clickButtonShowUnResolved">Show all unresolved Tickets</button>
             </b-col>
		</b-row>
        <b-row>
            <b-col>
                <br>
            </b-col>
        </b-row>
        <b-row >
            <b-col>
                <b>Select Site</b>
                <br>
                <select class="form-control" id="selectSites" style="overflow:scroll;"  v-model="selectedSite" @change="siteChanged">
                    <option value="" disabled> -- Select a site -- </option>  
                    <option v-for="site in sites"  v-bind:key="site.idSite" :value="site.idSite" >{{site.SiteName}}</option>		
                </select>
                <br>
            </b-col>
        </b-row>
         <b-row >
           <b-col>
                <select class="form-control" id="id_View" name="viewChoice" v-model="viewticketFilter" style="overflow:scroll;" @change="viewChoiceChanged">
                    <option value="0" >View Tickets</option>
                    <option value="1">View Jobs</option>
                    <option value="2">View All</option>
                </select>
           </b-col>
             <br><br>
         </b-row >
         <b-row >
           <br>
            <b-col class="text-center">
            <b>or</b>
            </b-col>
            <br>
        </b-row>
       <b-row >
            <b-col>
                <b>View employee unresolved jobs</b>
                <select  class="form-control"  style="overflow:scroll;" v-model="selectedUser" @change="employeeChanged">
                    <option value="" disabled> -- Select a Employee -- </option>
                    <option :value="user.idEmployee" v-for="user in users" v-bind:key="user.idEmployee" >{{user.employee}}</option>
                </select><br>
            </b-col>
       </b-row>

       <b-row >
            <b-col>
                 <div v-if="showlast10" >
                    <h3> Last 10 created tickets.</h3>
                </div>
                <img v-if="showLoader" src="img/ajax-loader.gif" class="center-block" alt="Loading ...">
                <br>
               
                <component-viewTicket v-for="ticket in filteredTickets" v-bind:key="ticket.idTicket" :idTicket="ticket.idTicket" :ticket="ticket"></component-viewTicket>
                <div v-if="showNoTickets" >
                    <h3> There are no tickets or jobs.</h3>
                </div>
               
            </b-col>
       </b-row>
    </b-container>    
  </div>
</template>

<script>
import axios from 'axios';
import viewTicket from '../components/viewTicket.vue'

export default {
  name: 'viewMyJobs',
 
   components: {
    'component-viewTicket' : viewTicket
   },
  data: () => ({
        users : null,
        showLoader : true,
        showNoTickets : false,
        selectedUser : '',
        sites : null,
        selectedSite : '',
        tickets : [],
        viewticketFilter : 0,
        whichMenu : -1,
        showlast10 : true,
        searchTicket : null
  }),
 methods: {
        submit : function() {
            console.log("Submit");
        },
        cancel : function() {
            console.log("Cancel");
        },
        siteChanged : function() {
            
            var mainObject = this;
            mainObject.showlast10 = false;
            mainObject.whichMenu = 1;
            mainObject.showLoader = true;
            mainObject.showNoTickets = false;
            mainObject.tickets = [];
            //console.log("siteChanged");
            axios.get(localStorage.getItem('ticketCopURL') +'/viewSelectedTickets', {
            params: {
                    idSite : mainObject.selectedSite
            },
             headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
                //console.log(response);
                if ( response.data != "error" )
                mainObject.tickets = response.data;
                
                //mainObject.ticketTagSubCategory_visible = true;

                })
                .catch(function () {
                //console.log(error);
                })
                .then(function () {
                // always executed
                //console.log("Made request to get sites for site "+mainObject.selectedSite);
                mainObject.showLoader = false;
                if ( mainObject.filteredTickets.length < 1 )
                {
                    mainObject.showNoTickets = true;
                }
            }); 

        },
        employeeChanged : function() {
            var mainObject = this;
            mainObject.showlast10 = false;
            mainObject.showLoader = true;
            mainObject.whichMenu = 2;
            mainObject.showNoTickets = false;
            mainObject.tickets = [];
            console.log("employeeChanged");
            axios.get(localStorage.getItem('ticketCopURL') +'/viewTicketsByEmployee', {
            params: {
                    idEmployee : mainObject.selectedUser
            },
             headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
            //console.log(response);
            if ( response.data != "error" )
            mainObject.tickets = response.data;
            
            //mainObject.ticketTagSubCategory_visible = true;

            })
            .catch(function () {
            //console.log(error);
            })
            .then(function () {
            // always executed
           // console.log("Made request to get tickets for user "+mainObject.selectedUser);
             mainObject.showLoader = false;
             if ( mainObject.filteredTickets.length < 1 )
                {
                    mainObject.showNoTickets = true;
                }
            }); 
        },
         clickButtonFindTicket : function() {
            var mainObject = this;
             mainObject.showlast10 = false;
            mainObject.whichMenu = 2;
            mainObject.showNoTickets = false;
            if (!isNaN(parseFloat(mainObject.searchTicket)) && isFinite(mainObject.searchTicket))
            //if (  !isNaN(mainObject.searchTicket) )
            {
                mainObject.showLoader = true;

                mainObject.tickets = [];
                //console.log("employeeChanged");
                //console.log(mainObject.searchTicket)
                axios.get(localStorage.getItem('ticketCopURL') +'/viewSpecificTicket', {
                params: {
                        idTicket :mainObject.searchTicket
                },
                 headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                })
                .then(function (response) {
                console.log(response);
                if ( response.data != "error" )
                mainObject.tickets = response.data;
                if ( response.data.length < 1 )
                 {
                     let timerInterval
                    mainObject.$swal({
                    //title: 'Auto close alert!',
                    html: 'Ticket number was not found.',
                    timer: 2000,
                    onBeforeOpen: () => {
                        mainObject.$swal.showLoading()
                        timerInterval = setInterval(() => {
                        mainObject.$swal.getContent().querySelector('strong')
                            
                        }, 100)
                    },
                    onClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
                    if (
                        // Read more about handling dismissals
                        result.dismiss === mainObject.$swal.DismissReason.timer
                    ) {
                        //console.log('I was closed by the timer');
                        //mainObject.$router.go(-1);
                    }
                    })  
                 }
                //mainObject.ticketTagSubCategory_visible = true;

                })
                .catch(function () {
                //console.log(error);
                })
                .then(function () {
                // always executed
                //console.log("Made request to get tickets for user"+mainObject.selectedUser);
                 mainObject.showLoader = false;
                 if ( mainObject.filteredTickets.length < 1 )
                {
                    mainObject.showNoTickets = true;
                }
                 

                }); 

            }
            else
            {
                 //bootbox.alert("Insert correct ticket value.", function () { });
                 let timerInterval
                    mainObject.$swal({
                    //title: 'Auto close alert!',
                    html: 'Insert correct ticket value.',
                    timer: 2000,
                    onBeforeOpen: () => {
                        mainObject.$swal.showLoading()
                        timerInterval = setInterval(() => {
                        mainObject.$swal.getContent().querySelector('strong')
                            
                        }, 100)
                    },
                    onClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
                    if (
                        // Read more about handling dismissals
                        result.dismiss === mainObject.$swal.DismissReason.timer
                    ) {
                        //console.log('I was closed by the timer');
                        //mainObject.$router.go(-1);
                    }
                    })  

            }

            
        },

        clickButtonShowUnResolved : function()
        {
            let mainObject = this;
             mainObject.showLoader = true;
            axios.get(localStorage.getItem('ticketCopURL') +'/viewUnrTickets', {
                params: {
                      
                },
                 headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                })
                .then(function (response) {
                //console.log(response);
                if ( response.data != "error" )
                    mainObject.tickets = response.data;
                    //console.log("No errors");

                })
                .catch(function () {
                //console.log(error);
                })
                .then(function () {
                // always executed
                //console.log("Made request to get tickets for user"+mainObject.selectedUser);
                 mainObject.showLoader = false;
                
                 

                }); 

        },
        viewChoiceChanged : function() {
            /*console.log("viewChoiceChanged");
            console.log(this.viewticketFilter);
            console.log(this.filteredTickets);*/


        }
          
          
  },
  computed: {
    filteredTickets : function () {
      var self = this;
      let ticketList = [];
      ticketList =  self.tickets.filter(function (ticket) {
        if ( self.whichMenu == 1 )
        {  
            if ( (self.viewticketFilter == 0 ) && (ticket.isJob == false ) )
            {
                return true;
            }
            if ( (self.viewticketFilter == 1 ) && (ticket.isJob == true ) )
            {
                return true;
            }
            if ( self.viewticketFilter == 2  )
            {
                return true;
            }
            return false;
        }
        else
        {
            return true;
        }
      })
      //console.log("ticketList length = "+ticketList.length);
      return ticketList;
    }
  },
    created: function () {
        var mainObject = this;
        // get all sites
        axios.get(localStorage.getItem('ticketCopURL') +'/getSites', {
          params: {

          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          //console.log(response);
          if ( response.data != "error" )
          mainObject.sites = response.data;
          
          //mainObject.ticketTagSubCategory_visible = true;

        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
          //console.log("Made request axios ticket to get sites");
          //mainObject.showLoader = false;
        }); 

        // get all users
        axios.get(localStorage.getItem('ticketCopURL') +'/getUsers', {
          params: {

          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          //console.log(response);
          if ( response.data != "Error" )
          mainObject.users = response.data.users;
          //mainObject.selectedUser = response.data.current_user;
         

        })
        .catch(function () {
          //console.log(error);
        })
        .then(function () {
          //console.log("Made request to get users");
        }); 
        axios.get(localStorage.getItem('ticketCopURL') +'/viewSelectedTickets', {
            params: {
                    showLast10 : true
            },
             headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
            console.log(response);
            if ( response.data != "error" )
            mainObject.tickets = response.data;
            
            //mainObject.ticketTagSubCategory_visible = true;

            })
            .catch(function () {
            //console.log(error);
            })
            .then(function () {
            // always executed
           // console.log("Made request to get tickets for user "+mainObject.selectedUser);
             mainObject.showLoader = false;
             if ( mainObject.filteredTickets.length < 1 )
                {
                    mainObject.showNoTickets = true;
                }
            }); 
        

    }
}
</script>
